import { SectionProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { PolicyChangeType, Quote } from '../../../../domain'
import { useErrorHandlingAsyncCallback } from '../../../../hooks/errors'
import { AddOnSection } from '../../../organisms/product/AddOnSection'
import { useProposal } from '../../proposal/ProposalProvider'

export interface RenewalAddOnSectionProps extends SectionProps {
  quote: Quote
}

export const RenewalAddOnSection: FunctionComponent<RenewalAddOnSectionProps> = ({
  quote,
  ...props
}) => {
  const { commit } = useProposal()

  const { loading, execute } = useErrorHandlingAsyncCallback(
    async (
      coverCode: string,
      changeType: PolicyChangeType.ADD_COVER | PolicyChangeType.REMOVE_COVER,
    ) =>
      await commit({
        changes: [{ changeType, coverOption: coverCode }],
      }),
  )

  return <AddOnSection loading={loading} quote={quote} onChange={execute} {...props} />
}
